import Constants from 'expo-constants';
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore';

export const getUserOrganizationCount = async (db, userId) => {
  const ownedQuery = query(
    collection(db, 'organizations'),
    where('ownerId', '==', userId)
  );
  const memberQuery = query(
    collection(db, 'organizations'),
    where('members', 'array-contains', userId)
  );

  const [ownedSnapshot, memberSnapshot] = await Promise.all([
    getDocs(ownedQuery),
    getDocs(memberQuery),
  ]);

  const orgIds = new Set();
  ownedSnapshot.forEach((d) => orgIds.add(d.id));
  memberSnapshot.forEach((d) => orgIds.add(d.id));
  return orgIds.size;
};

export const getMaxOrgsPerUser = () =>
  parseInt(
    Constants.expoConfig?.extra?.maxOrgsPerUser ||
      process.env.EXPO_PUBLIC_MAX_ORGS_PER_USER ||
      '0',
    10
  );

export const createOrganizationForUser = async (db, user) => {
  const orgRef = await addDoc(collection(db, 'organizations'), {
    ownerId: user.uid,
    ownerEmail: user.email || null,
    members: [user.uid],
    isPublic: false,
    username: '',
    title: '',
    location: '',
    bio: '',
    description: '',
    photoURL: null,
    media: [],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  const userRef = doc(db, 'users', user.uid);
  const userDoc = await getDoc(userRef);
  const userDocData = userDoc.exists() ? userDoc.data() : {};
  const currentOrganizations = userDocData.organizations || {};

  await updateDoc(userRef, {
    organizations: {
      ...currentOrganizations,
      [orgRef.id]: {
        role: 'owner',
        joinedAt: serverTimestamp(),
      },
    },
  });

  return {
    id: orgRef.id,
    ownerId: user.uid,
    ownerEmail: user.email || null,
    members: [user.uid],
    isPublic: false,
    username: '',
    title: '',
    location: '',
    bio: '',
    description: '',
    photoURL: null,
    media: [],
    role: 'owner',
    canPostAsOrganization: true,
    isOrgOwner: true,
  };
};
